import { useState, useEffect } from 'react';

export function useIsMobile(breakpoint = 640) {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint
  );
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, [breakpoint]);
  return isMobile;
}

export function useWindowWidth() {
  const [w, setW] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : 1024));
  useEffect(() => {
    const h = () => setW(window.innerWidth);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return w;
}

// Helpers de estilo responsive
export const rp = (mobile, desktop) => (isMobileVal) => isMobileVal ? mobile : desktop;

export const responsiveGrid = (cols, isMobile, isTablet) => ({
  display: 'grid',
  gridTemplateColumns:
    isMobile  ? `repeat(${Math.min(2, cols)}, 1fr)` :
    isTablet  ? `repeat(${Math.min(3, cols)}, 1fr)` :
                `repeat(${cols}, 1fr)`,
  gap: isMobile ? 10 : 16,
});

export const pageContainer = (isMobile) => ({
  padding: isMobile ? '16px 14px' : '28px 32px',
  background: '#fafbfd',
  minHeight: '100vh',
  fontFamily: 'Inter, system-ui, sans-serif',
});

export const tableWrap = {
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  borderRadius: 12,
};
